import React from 'react';
import {Navigate,useLocation} from 'react-router-dom';
import {useOrganization} from '../context/OrganizationContext';
import {canCustomerPage} from '../customerAccess';
export default function CustomerAccessRoute({children}) {
 const {activeOrganization,organizationReady}=useOrganization();
 const location=useLocation();
 if(!organizationReady)return <div role="status" style={{padding:32}}>Loading workspace…</div>;
 if(!canCustomerPage(activeOrganization,location.pathname))return <Navigate to="/dashboard" replace/>;
 return <React.Fragment key={(activeOrganization?.guid||'personal')+':'+(activeOrganization?.membership_role||'')}>{children}</React.Fragment>;
}
